import React from 'react'
import tw from "twin.macro";
import {Link} from 'react-router-dom'

const ButtonContainer = tw.div`flex justify-center md:mt-10 mt-5 cursor-pointer`;
const LoadMoreButton = tw.text` text-gray-500 mx-auto text-sm md:text-lg border-2 px-2 py-1 rounded-sm`;

function ReadMoreButton({link, handleLoadMoreData}) {
  return (
    <ButtonContainer onClick={() => handleLoadMoreData()}>
      {/* <Link to={`/${link}`}> */}
        <LoadMoreButton>Read More</LoadMoreButton>
      {/* </Link> */}
    </ButtonContainer>
  )
}

export default ReadMoreButton